import { ReportConfig } from "../definitions";

const brokerWrittenReport: ReportConfig = {
  id: "brokerWrittenReport",
  name: "Broker Written Report",
  options: [
    { name: "startDate", label: "Start Date", dataType: "date", defaultValue: "$YEAR-01-01" },
    { name: "endDate", label: "End Date", dataType: "date", defaultValue: "$YEAR-$MONTH-$DAY" },
    {
      name: "broker",
      label: "Broker",
      dataType: "select-dynamic",
      optionsDataSource: {
        sql: `
SELECT '' AS [ID], '-- Select Broker --' AS [Name]
UNION ALL
SELECT DISTINCT b.[ID], CONCAT(b.FirstName, ' ', b.LastName) as [Name]
FROM awu.Application a
    INNER JOIN awu.ApplicationBroker ab ON a.ID = ab.ApplicationID
    INNER JOIN dbo.Broker b ON ab.BrokerID = b.ID
WHERE b.[IsDeleted] IS NULL OR b.[IsDeleted] = 0
ORDER BY [Name]
`,
        returnType: "options",
      },
    },
  ],
  layout: [
    {
      items: [
        {
          id: "item-1",
          title: "",
          widgetType: "table",
          columns: [
            { name: "Company", type: "string" },
            { name: "Applicant", type: "string" },
            { name: "Status", type: "string" },
            { name: "Policy Number", type: "string" },
            { name: "Type", type: "string" },
            { name: "Paid Premium", type: "currency", align: "right", summary: "sum" },
            { name: "Submitted", type: "date" },
          ],
          dataSource: {
            sql: `
IF @broker = ''
BEGIN
  PRINT 'You must select a broker'
  RETURN
END
ELSE
BEGIN

SELECT
    cr.Type AS [Carrier],
    CONCAT(a.Firstname, ' ', a.LastName) AS [Applicant],
    ast.Description AS [Status],
    a.PolicyNumber,
    plt.[Description] AS [Product],
    ap.AnnualizedPremium * ab.[CommissionPercent] AS [Premium],
    a.[EntryDate]
FROM awu.Application a
    INNER JOIN awu.ApplicationBroker ab ON a.ID = ab.ApplicationID
    INNER JOIN [dbo].CarrierType cr ON a.CarrierID = cr.ID
    INNER JOIN awu.ApplicationStatus ast ON a.ApplicationStatusID = ast.ID
    INNER JOIN dbo.Broker b ON ab.BrokerID = b.ID AND b.ID = @broker
    INNER JOIN awu.[Plan] pl ON a.PlanID = pl.ID
    INNER JOIN awu.[PlanType] plt ON pl.[PlanTypeID] = plt.ID
    INNER JOIN awu.ApplicationPremium ap ON a.ID = ap.ApplicationID
WHERE
    a.IsDeleted IS NULL OR a.IsDeleted = 0
    AND a.EntryDate BETWEEN @startDate AND @endDate
    AND ast.ScenarioTypeCode = 'F'
    AND (@_branch = 0 OR a.BranchTypeID = @_branch)
ORDER BY [Carrier], [EntryDate], [PolicyNumber], ab.CommissionLevel
END
            `,
            returnType: "table",
          },
          options: { summary: true, zebraFieldIndex: [3, 1] },
        },
      ],
    },
  ],
};

export default brokerWrittenReport;
